<template>
    <div class="modal fade" :id="idModalOwnerRe" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">EMBARCACION {{ nameShip }} </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-row">
                        <div class="form-group col-12 col-md-3">
                            <label for="type_identification" class="badge badge-secondary">Busqueda Propietario</label>
                        </div>
                        <div class="form-group col-12 col-md-7">
                            <vue-bootstrap-typeahead                            
                                v-model="queryOwnerRe"
                                :data="ownersRectification"
                                size="sm"
                                :serializer="item => (item.nombre_propietario +' '+item.dato_identificacion)"
                                @hit="mSelectedOwner"
                                :placeholder="searchOwner"                                        
                            />
                        </div>
                        <button type="button" class="btn btn-warning btn-sm col-12 col-md-1" @click="mResetSelectOwner" value="no"><font-awesome-icon icon="redo-alt" /> </button>
                    </div>
                    
                    
                        <div class="form-row">
                            <div class="form-group col-12 col-md-4">
                                <label for="type_identification" class="badge badge-primary">Tipo Identificacion</label>
                                <select class="form-control" name="type_ship" v-model="owner.type_identification" :disabled="d_owner_disabled" @change="mChangeOwnerIdentification">
                                    <option v-for="identification in typesIdentification" :value="identification.id" :key="identification.id">{{ identification.detail }}</option>
                                </select>
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="number_identification" class="badge badge-primary">Numero Identificacion </label>
                                <input type="text" class="form-control" v-model="owner.number_identification" name="number_identification" placeholder="Numero de Identificacion" :disabled="d_owner_disabled" autocomplete="off">
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="site_expedition" class="badge badge-primary">Lugar Emision </label>
                                <select class="form-control" name="site_expedition" v-model="owner.site_expedition" :disabled="d_owner_disabled">
                                    <option v-for="city in citys" :value="city.id" :key="city.id">{{ city.detail }}</option>
                                </select>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12 col-md-6">
                                <label for="owner_name" class="badge badge-primary">Nombre Propietario</label>
                                <input type="text" class="form-control" v-model="owner.name" name="owner_name" placeholder="Nombre Propietario" autocomplete="off" :disabled="d_owner_disabled">
                            </div>

                            <div class="form-group col-12 col-md-6">
                                <label for="owner_direction" class="badge badge-primary">Direccion </label>
                                <input type="text" class="form-control" v-model="owner.direction" name="owner_direction" placeholder="Direccion" autocomplete="off" :disabled="d_owner_disabled">
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12 col-md-6">
                                <label for="owner_celular" class="badge badge-primary">Celular </label>
                                <input type="number" class="form-control" v-model="owner.mobile" name="owner_celular" placeholder="Celular" autocomplete="off" :disabled="d_owner_disabled">
                            </div>

                            <div class="form-group col-12 col-md-6">
                                <label for="phone_static" class="badge badge-primary">Telefono Fijo </label>
                                <input type="number" class="form-control" v-model="owner.phone" name="phone_static" placeholder="Telefono Fijo" autocomplete="off" :disabled="d_owner_disabled">
                            </div>
                        </div>
                            
                        <div class="form-row">
                            <div class="form-group col-12 col-md-6">
                                <label for="owner_partner" class="badge badge-primary">Representante Legal </label>
                                <input type="text" class="form-control" v-model="owner.partner" name="owner_partner" placeholder="Representante Legal" autocomplete="off" :disabled="d_disabled_partner">
                            </div>

                            <div class="form-group col-12 col-md-6">
                                <label for="owner_nationality" class="badge badge-primary">Nacionalidad </label>
                                <select class="form-control" name="owner_nationality" v-model="owner.nationality" :disabled="d_owner_disabled">
                                    <option v-for="country in countrys" :value="country.id" :key="country.id">{{ country.detail }}</option>
                                </select>
                            </div>
                        </div>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-success" :disabled="btnSend" @click="mValidateOwner" v-if="isEditable"><font-awesome-icon icon="save" size="lg" /></button>
                    <button type="button" class="btn btn-outline-danger" data-dismiss="modal"><font-awesome-icon icon="times-circle" size="lg" /></button>   
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';

const qs =require('qs');

export default {
    name:'modal-owner',
    props:{
        idModalOwnerRe:String,
        owner:Object,
        nameShip:String,
        typesIdentification:Array,
        countrys:Array,
        citys:Array,
        isEditable:{
            type:Boolean,
            default:true
        }
    },
    data(){
        return {
            queryOwnerRe:'',
            ownersRectification:[],
            searchOwner:'Busqueda Propietario',
            types_identification:[],
            d_owner_disabled:false,
            d_disabled_partner:false,
            btnSend:false,
            // owner:{
            //     id:0,
            //     type_identification:null,
            //     number_identification:null,
            //     site_expedition:null,
            //     name:null,
            //     direction:null,
            //     mobile:null,
            //     phone:null,
            //     partner:null,
            //     nationality:null
            // }
        }
    },
    methods:{
        mSelectedOwner(data){
            // console.log(data);
            this.owner.id=data.id_propietario;
            this.owner.type_identification=data.tipo_identificacion;
            this.owner.number_identification=data.dato_identificacion;
            this.owner.site_expedition=data.id_expedido;
            this.owner.name=data.nombre_propietario;
            this.owner.direction=data.domicilio;
            this.owner.mobile=data.celular;
            this.owner.phone=data.telefono_fijo;
            this.owner.partner=data.representante_legal;
            this.owner.nationality=data.id_nacionalidad;
        },
        mValidateOwner(){
            let ce=0;            

            if(!this.owner.nationality){                
                toastr.error('Indique la Nacionalidad del Titular','Nacionalidad');
                ce++;
            }
            if(!this.owner.type_identification){
                toastr.error('seleccione un tipo de identificacion','Identificacion');
                ce++;
            }
            if(!this.owner.number_identification){
                toastr.error('Indique un numero de identificacion','Numero Indenficacion');
                ce++;
            }
            if(!this.owner.site_expedition){
                toastr.error('Seleccione el departamento de Emision','Emision de Cedula');
                ce++;
            }
            if(!this.owner.name){
                toastr.error('Indique el Nombre del Propietario','Nombre Propietario');
                ce++;
            }

            if(ce===0){
                this.mSaveOwner();
            }
        },
        mSaveOwner(){

            let idvsp={
                idMaster:this.owner.idvs,
                idShip:this.owner.idShip,
                idOwner:JSON.stringify(this.owner)
            }
            let env={
                dts:JSON.stringify(idvsp)
            }

            // console.log(this.owner)
            toastr.info("Asignando al propietario")
            axios.post(`updateOwner?api_token=${Vue.auth.getToken()}`, qs.stringify(idvsp))
            // axios.post(`updateOwner`, qs.stringify(env))
                    .then((res)=>{
                        if(res.data[0].status){
                            if(parseInt(res.data[1].idvs) > 0){
                                this.owner.idvs=res.data[1].idvs;
                                toastr.success(res.data[0].respuesta)
                            }else{
                                toastr.error('Ha courrido un error al actualizar el propietario');
                            }
                        }else{
                            toastr.error(res.data[0].respuesta);
                        }
                    })
                    .catch(err=>{
                        console.error(err);
                    })

        },
        mResetSelectOwner(){
            this.owner.id=0;
            this.owner.type_identification=null;
            this.owner.number_identification=null;
            this.owner.site_expedition=null;
            this.owner.name=null;
            this.owner.direction=null;
            this.owner.mobile=null;
            this.owner.phone=null;
            this.owner.partner=null;
            this.owner.nationality=null;
            this.d_owner_disabled=false;
            this.d_disabled_partner=false;
        },
        mChangeOwnerIdentification(){
            
            switch(this.owner.type_identification){
                case 17:
                // cedula identidad
                    this.d_disabled_partner=true;
                break;

                case 18:
                // nit
                    this.d_disabled_partner=false;
                break;
            }
        }
    },
    watch:{
        queryOwnerRe(newOwner) {
            if(newOwner.length >= 4){
                // axios.get(`searchOwner/${newOwner}`)
                axios.get(`searchOwner/${newOwner}?api_token=${Vue.auth.getToken()}`)
                    .then((res) => {                    
                        this.ownersRectification = res.data
                        // this.users = res.data.items
                    }).catch(error => {
                        console.log(error);
                    })
            }
                           
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/rectification/ModalOwner.vue